import { PRDService, ToastService } from "@/services";

const getDefaultState = () => {
  return {
    newOrder: null,
    order: null,
    product: null,
    components: [],
    componentMachines: [],
    componentLots: null,
    activeMachines: [],
    newComponent: "",
    batchDisplayed: [],
    updatingComponents: [],
    currentTask: "",
    surplusMachines: null,
    missingMachines: null,
    error: null,
    fetching: false,
    posting: false,
    errorAnalysis: null
  };
};

const state = getDefaultState();

const actions = {
  resetState({ commit }) {
    commit("resetState");
  },
  getProduct({ dispatch, commit }, { product_name, product_brand }) {
    commit("setFetching", true);
    PRDService.fetchProduct(product_name, product_brand)
      .then(({ data }) => commit("setProduct", data))
      .finally(() => commit("setFetching", false));
  },
  getOrder({ dispatch, commit }, manufacture_number) {
    commit("resetState");
    PRDService.getManufactureOrder(1, manufacture_number).then(
      ({ status, data }) => {
        if (status === 200) {
          commit("setOrder", data);
          dispatch("getOrderComponents");
          dispatch("getActiveMachines");
          // dispatch("getComponentMachines");
          // dispatch("getOrderMachines");
        }
      }
    );
  },
  createOrder({ dispatch, commit, state }) {
    commit("setTask", "Preparando formato de orden");

    PRDService.createManufactureOrder({
      product_name: state.product.product_name,
      product_brand: state.product.product_brand,
      manufacture_type: 1,
      machine_total: state.newOrder.machineTotal,
      batch_total: state.newOrder.batchTotal
    })
      .then(({ status, data }) => {
        commit("resetState");
        if (status === 200) {
          commit("setErrorAnalysis", data);
        } else {
          commit("setOrder", data);
          dispatch("getOrderComponents");
        }
      })
      .finally(() => commit("setTask"));
  },
  updateOrder({ commit, state }) {
    const { id = 0, manufacture_date, status } = state.order;

    if (id === 0) return;

    return PRDService.updateManufactureOrder({
      id,
      manufacture_date,
      status
    }).then(({ status }) => {
      if (status === 200) {
        commit("resetState");
      }
    });
  },
  deleteOrder({ state, commit }) {
    commit("setTask", "Eliminando orden");
    PRDService.deleteManufactureOrder(state.order.id)
      .then(({ status }) => {
        if (status === 200) {
          commit("resetState");
        }
      })
      .finally(() => commit("setTask"));
  },
  async processOrder({ state, commit, dispatch }) {
    const { id } = state.order;
    if (id === 0) return;

    await dispatch("updateOrder");
    commit("setTask", "Procesando orden");

    PRDService.processManufactureOrder(id)
      .then(({ data, status }) => {
        if (status === 200) {
          if (data && data.errors) {
            commit("setErrorAnalysis", data.errors);
          } else {
            ToastService.success("La orden ha sido procesada exitosamente.");
            commit("resetState");
          }
        }
      })
      .catch(() => commit("resetState"));
  },
  getActiveMachines({ commit, state }) {
    if (!state.order) return;

    return PRDService.getActiveMachines(state.order.id).then(({ data }) => {
      commit("setActiveMachines", data.activeMachines);
      commit("setSurplusMachines", data.warnings);
      commit("setMissingMachines", data.errors);
    });
  },
  getOrderComponents({ commit, state, dispatch }) {
    PRDService.fetchManufactureOrderComponents(
      state.order.manufacture_type,
      state.order.manufacture_number
    ).then(({ data }) => {
      commit("setOrderComponents", data);
    });
  },
  getOrderComponent({ commit }, id) {
    PRDService.fetchManufactureOrderComponent(id).then(({ data }) => {
      commit("setOrderComponent", data);
    });
  },
  getComponentMachines({ commit, state }) {
    const { manufacture_type, manufacture_number } = state.order;

    PRDService.fetchManufactureOrderComponentMachines(
      manufacture_type,
      manufacture_number
    ).then(({ data }) => commit("setComponentMachines", data));
  },
  createComponent({ commit, state }, product_code) {
    if (product_code === "") return;

    const id = state.order.id;

    return PRDService.createManufactureOrderComponent(id, product_code).then(
      ({ data }) => commit("addComponent", data)
    );
  },
  updateComponent({ commit }, { id, qty_in_machine }) {
    commit("setUpdatingComponent", id);
    PRDService.updateManufactureOrderComponent(id, qty_in_machine)
      .then(({ data, status }) => {
        commit("setOrderComponent", data);
      })
      .finally(() => commit("setUpdatingComponent", id));
  },

  createOrUpdateMachineQty(
    { state, dispatch, commit },
    { id, batch, machine, qty_required }
  ) {
    commit("setUpdatingComponent", id);
    PRDService.createOrUpdateManufactureOrderComponentMachine(
      id,
      batch,
      machine,
      qty_required
    )
      .then(({ data, status }) => {
        if (status === 201) {
          commit("addComponentMachine", data);
        } else {
          const {
            id,
            component_seq_number,
            batch,
            qty_required,
            machine
          } = data;
          commit("updateMachineQty", { id, batch, qty_required, machine });
          dispatch("getOrderComponentLots", component_seq_number);
        }
        dispatch("getOrderComponent", id);
        if (
          state.activeMachines.find(
            el => el.component_seq_number === data.component_seq_number
          )
        ) {
          dispatch("getActiveMachines");
        }
      })
      .finally(() => commit("setUpdatingComponent", id));
  },
  createOrUpdateAllMachineQty(
    { state, dispatch, commit },
    { id, batch, qty_required }
  ) {
    commit("setUpdatingComponent", id);
    return PRDService.updateOrderComponentAllMachines(id, batch, qty_required)
      .then(({ data, status }) => {
        for (let row of data.result) {
          if (row.created) {
            commit("addComponentMachine", row.component_machine);
          } else {
            commit("updateMachineQty", {
              id: row.component_machine.id,
              batch: row.component_machine.batch,
              qty_required: row.component_machine.qty_required,
              machine: row.component_machine.machine
            });
          }
        }

        dispatch("getOrderComponentLots", data.component_seq_number);
        dispatch("getOrderComponent", id);

        if (
          state.activeMachines.find(
            el => el.component_seq_number === data.component_seq_number
          )
        ) {
          dispatch("getActiveMachines");
        }

        // dispatch("getComponentMachineBySeqNumber", data.component_seq_number)
      })
      .finally(() => {
        commit("setUpdatingComponent", id);
      });
  },
  getOrderComponentLots({ commit, state }, component_seq_number) {
    const { manufacture_type, manufacture_number } = state.order;

    PRDService.fetchManufactureOrderComponentLots(
      manufacture_type,
      manufacture_number,
      component_seq_number
    ).then(({ data }) =>
      commit("setComponentLots", { data, component_seq_number })
    );
  },
  getComponentBatchBySeqNumber({ commit, state }, component_seq_number) {
    const { manufacture_type, manufacture_number } = state.order;

    PRDService.fetchComponentBatchesBySeqNumber(
      manufacture_type,
      manufacture_number,
      component_seq_number
    ).then(({ data }) =>
      commit("setComponentMachinesBySeqNumber", { data, component_seq_number })
    );
  },
  assignComponentLot({ dispatch }, data) {
    const { component_id, lot_id, location_code: locationCode, lot_qty } = data;

    PRDService.manufactureOrderComponentLotAssignment({
      component_id,
      lot_id,
      lot_qty
    }).then(({ data, status }) => {
      if (status === 200) {
        const { product_code: productCode, component_seq_number } = data;
        dispatch("getOrderComponentLots", component_seq_number);
        dispatch(
          "inventory/fetchLotMaster",
          { productCode, locationCode },
          { root: true }
        );
      }
    });
  },
  releaseComponentLot({ dispatch }, { id, location_code: locationCode }) {
    PRDService.manufactureOrderComponentLotRelease(id).then(
      ({ data, status }) => {
        if (status === 200) {
          const { product_code: productCode, component_seq_number } = data;

          dispatch("getOrderComponentLots", component_seq_number);
          dispatch(
            "inventory/fetchLotMaster",
            { productCode, locationCode },
            { root: true }
          );
        }
      }
    );
  }
};

const mutations = {
  resetState: state => Object.assign(state, getDefaultState()),
  setFetching: (state, payload) => (state.fetching = payload),
  setUpdatingComponent: (state, payload) => {
    if (state.updatingComponents.includes(payload)) {
      state.updatingComponents = state.updatingComponents.filter(
        el => el !== payload
      );
    } else {
      state.updatingComponents.push(payload);
    }
  },

  setTask: (state, payload = "") => (state.currentTask = payload),
  setActiveMachines: (state, machines) => {
    // state.activeMachines = state.activeMachines.filter(el => el[0] !==  )
    state.activeMachines = machines;
  },
  setSurplusMachines: (state, payload) => (state.surplusMachines = payload),
  setMissingMachines: (state, payload) => (state.missingMachines = payload),
  setProduct: (state, product) => (state.product = product),
  setOrder: (state, order) => (state.order = order),
  setOrderStatus: (state, payload) => (state.order.status = payload),
  setOrderDate: (state, payload) => (state.order.manufacture_date = payload),
  setNewOrder: (state, payload) => (state.newOrder = payload),
  updateNewOrder: (state, { key, value }) => (state.newOrder[key] = value),
  addComponent: (state, component) => state.components.push(component),
  setOrderComponents: (state, components) => {
    state.components = components.map(el => ({ ...el, _lots: [] }));
  },
  setOrderComponent: (state, component) => {
    let index = state.components.findIndex(el => el.id === component.id);
    if (index >= 0) {
      state.components[index].qty_required = component.qty_required;
      state.components[index].qty_on_hand = component.qty_on_hand;
      state.components[index].qty_allocated = component.qty_allocated;
      state.components[index].qty_in_machine = component.qty_in_machine;
      state.components[index].remaining_machines = component.remaining_machines;
    }
  },
  updateMachineQty: (state, data) => {
    let index = state.componentMachines.findIndex(el => el.id === data.id);
    if (index >= 0) {
      state.componentMachines[index].qty_required = data.qty_required;
    }
  },
  setComponentMachinesBySeqNumber: (state, { component_seq_number, data }) => {
    let filtered = state.componentMachines.filter(
      el => el.component_seq_number !== component_seq_number
    );
    state.componentMachines = filtered;
    state.componentMachines.push(...data);
  },
  setComponentMachines: (state, data) => (state.componentMachines = data),
  addComponentMachine: (state, data) => {
    state.componentMachines.push(data)
  },
  setComponentLots: (state, { data, component_seq_number }) => {
    let index = state.components.findIndex(
      el => el.seq_number === component_seq_number
    );
    if (index < 0) return;

    state.components[index]._lots = data;
  },
  setErrorAnalysis: (state, errorAnalysis) =>
    (state.errorAnalysis = errorAnalysis),
  setPosting: (state, payload) => (state.posting = payload),
  toggleBatchDisplayed: (state, seq_number) => {
    if (state.batchDisplayed.includes(seq_number)) {
      state.batchDisplayed = state.batchDisplayed.filter(el => {
        return el !== seq_number;
      });
    } else {
      state.batchDisplayed.push(seq_number);
    }
  }
};

const getters = {
  activeMachines: state => state.activeMachines.sort(),
  orderComponents: state => state.components,
  componentByMachine: state => (machine_name, seq_number) => {
    let index = state.componentMachines.findIndex(
      el =>
        el.machine_name === machine_name &&
        el.component_seq_number === seq_number
    );
    if (index === -1) return null;

    return state.componentMachines[index];
  },
  componentLots: state => state.componentLots,
  getMachine: state => (seq_number, batch, machine) =>
    state.componentMachines.find(
      el =>
        el.component_seq_number === seq_number &&
        el.batch === batch &&
        el.machine === machine
    ),
  posting: state => state.posting,
  machineName: state =>
    state.order ? state.order.machine_name[0].toUpperCase() : ""
};

export const prdManufactureOrder = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/prd.manufacture.module.js